import type { AdminStepScorm } from '@/entities/Courses';
import { isScormUploadResumable } from '../lib/scormState';

interface StepScormServerStatusProps {
  scorm: AdminStepScorm;
}

/**
 * Незавершённая загрузка пакета шага по данным сервера, когда с этого компьютера она не идёт:
 * идёт в другой вкладке, прервана или брошена. Идущую отсюда загрузку показывает
 * StepScormUploadStatus, обработку и готовый пакет — карточка шага.
 */
export const StepScormServerStatus = ({ scorm }: StepScormServerStatusProps) => {
  if (scorm.processingStatus !== 'uploading') {
    return null;
  }

  const fileName = scorm.upload?.fileName;
  return (
    <div className="flex flex-col gap-1 rounded-lg bg-gray-50 p-4 text-sm">
      <p className="font-medium text-black-headline">
        {fileName
          ? `The upload of “${fileName}” has not finished`
          : 'The upload of the SCORM package has not finished'}
      </p>
      <p className="text-grey-secondary">
        It may still be running in another tab or browser.{' '}
        {isScormUploadResumable(scorm)
          ? 'If it was interrupted, choose the same file again and the upload continues from where it stopped; a different file replaces the package.'
          : 'If it was interrupted, upload the file again or remove the package.'}{' '}
        Students do not see this step&apos;s package until it is ready.
      </p>
    </div>
  );
};
